import {Route} from "react-router-dom";
import PrivateRoute from "context/PrivateRoute";
import MainRouteManagement from "./MainRouteManagement";
import ViewProgramming from "./ViewProgramming";
import ViewZones from "./ViewZones";
import RouteStaic from "./ViewRouteStatic";
import ViewDynamic from "./ViewDynamic";
import ViewWaypoints from "./ViewWaypoints";
import FormTemplate from "./dynamic/FormTemplate";
import ViewCalendar from "./ViewCalendar";
import FormRoute from "./scheduler/route/FormRoute";
import ViewRouteFly from "./ViewRouteFly";

// prettier-ignore
const RoutesManagement = () => {
       return (
           <>
               <Route
                   path="route-management"
                   element={
                       <PrivateRoute role="tech" panelType="w">
                           <MainRouteManagement />
                       </PrivateRoute>
                   }
               />
               <Route
                   path="route-management/programing"
                   element={
                       <PrivateRoute role="admin" panelType="w">
                           <ViewProgramming />
                       </PrivateRoute>
                   }
               />
               <Route
                   path="route-management/areas"
                   element={
                       <PrivateRoute role="admin" panelType="w">
                           <ViewZones />
                       </PrivateRoute>
                   }
               />
               <Route
                   path="route-management/routes-dynamic"
                   element={
                       <PrivateRoute role="tech" panelType="w">
                           <ViewDynamic />
                       </PrivateRoute>
                   }
               />
               <Route
                   path="route-management/routes-dynamic/template/:id"
                   element={
                       <PrivateRoute role="tech" panelType="w">
                           <FormTemplate />
                       </PrivateRoute>
                   }
               />
               <Route
                   path="route-management/routes-static"
                   element={
                       <PrivateRoute role="tech" panelType="w">
                           <RouteStaic />
                       </PrivateRoute>
                   }
               />
               <Route
                   path="route-management/routes-fly"
                   element={
                       <PrivateRoute role="tech" panelType="w">
                           <ViewRouteFly />
                       </PrivateRoute>
                   }
               />
               <Route
                   path="route-management/waypoints"
                   element={
                       <PrivateRoute role="admin" panelType="w">
                           <ViewWaypoints />
                       </PrivateRoute>
                   }
               />
               <Route
                   path="route-management/calendar"
                   element={
                       <PrivateRoute role="tech" panelType="w">
                           <ViewCalendar />
                       </PrivateRoute>
                   }
               />
               <Route
                   path="route-management/route/:idParams"
                   element={
                       <PrivateRoute role="tech" panelType="w">
                           <FormRoute />
                       </PrivateRoute>
                   }
               />
           </>
       );
}
export default RoutesManagement;
